import { render, staticRenderFns } from "./refreshCfg.vue?vue&type=template&id=0f34326d&scoped=true&"
import script from "./refreshCfg.vue?vue&type=script&lang=js&"
export * from "./refreshCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f34326d",
  null
  
)

export default component.exports